import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { LogoutPostRequestModel, LogoutPostResponseModel } from "@/features/auth/services/logout-model";

export class LogoutApi {
  /**
   * ログアウト
   */
  public postLogout = async (
    param: LogoutPostRequestModel
  ): Promise<LogoutPostResponseModel> => {
    const path = `/api/logout`;
    const res = await ApiClient.instance.post<LogoutPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
